var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 17a2 2 0 110 4 2 2 0 010-4zm10 0a2 2 0 110 4 2 2 0 010-4zM5 0a1 1 0 01.947.678l.03.112.69 3.215h17.33a1 1 0 01.997 1.08l-.017.115-1.996 9.991a1 1 0 01-.863.797l-.118.007H8a1 1 0 01-.947-.678l-.03-.112L4.191 2H1a1 1 0 01-.993-.883L0 1A1 1 0 01.883.007L1 0h4zm17.778 6.005H7.096l1.713 7.991h12.372l1.597-7.991z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--cart-dc361ba28a80b28d89f280173a883f1b.svg";
export { SvgIconUiCart as Component };